import * as React from "react"
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import useRepos from './useRepos'

function Repos() {
  const [selection, setSelection] = React.useState('created')
  const { data, status,refetch } = useRepos(selection)

  if (status === 'pending') {
    return <div>...</div>
  }

  if (status === 'error') {
    return <div>There was an error fetching the data.</div>
  }

  return (
    <div>
      <label>
        Sort by:
        <select
          value={selection}
          onChange={(event) => {
            const sort = event.target.value
            setSelection(sort)
            refetch()
        }}>
          <option value="created">Created</option>
          <option value="updated">Updated</option>
          <option value="pushed">Pushed</option>
          <option value="full_name">Name</option>
        </select>
      </label>
      <ul>
        { data.map(repo => <li key={repo.id}>{repo.full_name}</li>) }
      </ul>
    </div>
  )
}

const queryClient = new QueryClient()

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Repos />
    </QueryClientProvider>
  )
}